/**
 * created on: 2019-03-29
 * 广电广电文稿-电视稿路由
 */
"use strict";
angular.module('televisionRouterModule', []).
config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {
    $stateProvider.state('front.editctr.television', {
        url: '/television?doctype',
        views: {
            "television@front.editctr": {
                templateUrl: './editingCenter/television/left_tpl.html',
                controller: 'televisionLeftCtrl'
            }
        }
    })
}]);